export const GridIcon = ({ color = "black" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3H3.33333C3.14924 3 3 3.14924 3 3.33333V6C3 6.18409 3.14924 6.33333 3.33333 6.33333H6C6.18409 6.33333 6.33333 6.18409 6.33333 6V3.33333C6.33333 3.14924 6.18409 3 6 3Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9H9.33333C9.14924 9 9 9.14924 9 9.33333V12C9 12.1841 9.14924 12.3333 9.33333 12.3333H12C12.1841 12.3333 12.3333 12.1841 12.3333 12V9.33333C12.3333 9.14924 12.1841 9 12 9Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3H9.33333C9.14924 3 9 3.14924 9 3.33333V6C9 6.18409 9.14924 6.33333 9.33333 6.33333H12C12.1841 6.33333 12.3333 6.18409 12.3333 6V3.33333C12.3333 3.14924 12.1841 3 12 3Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 9H3.33333C3.14924 9 3 9.14924 3 9.33333V12C3 12.1841 3.14924 12.3333 3.33333 12.3333H6C6.18409 12.3333 6.33333 12.1841 6.33333 12V9.33333C6.33333 9.14924 6.18409 9 6 9Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
